import React from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { Field, Fields } from "redux-form";
import { Check, CheckGroup, FormRow } from "MODULES/shared/components/Forms";
import {
  WAREHOUSE_LOGISTICS_DIRECTOR,
  WAREHOUSE_MANAGER,
  WAREHOUSE_EXPERT
} from "MODULES/users/constants";

import * as FormTypes from "MODULES/shared/components/Forms/FormTypes";
import { properCase } from "LIB/formatters/text";
import {
  BIO_HAZMAT,
  EXPORT_COMPLIANCE,
  HAZMAT,
  LLP,
  MILITARY,
  PASS_FAIL,
  SHELF_LIFE,
  TOTAL_CYCLES,
  TOTAL_HOURS
} from "MODULES/parts/constants";
import { disableIfHasAnyOfSubroles } from "MODULES/users/helpers";
import { useCurrentUser } from "APP_ROOT/hooks";
import PartTypes from "MODULES/shared/components/PartTypes/PartTypes";
import TotalTimeFields from "./TotalTimeFields";

export function Warnings({
  formName,
  hazmat,
  bio_hazmat: bio,
  llp,
  pass_fail,
  military
}) {
  const user = useCurrentUser();
  const disableIfWarehouseDirector = disableIfHasAnyOfSubroles(user, [
    WAREHOUSE_LOGISTICS_DIRECTOR
  ]);
  const disableIfWhManager = disableIfHasAnyOfSubroles(user, [
    WAREHOUSE_EXPERT,
    WAREHOUSE_MANAGER
  ]);

  return (
    <React.Fragment>
      <FormRow>
        <Col md={4}>
          <CheckGroup
            title={properCase(HAZMAT)}
            justified
            info="A hazardous material note will be added to outgoing quote and sales order confirmation emails. Notifies receiving dept."
          >
            <Check
              input={hazmat.input}
              label={properCase(HAZMAT)}
              icon="fa-warning"
              disabled={disableIfWhManager}
            />
          </CheckGroup>
        </Col>
        <Col md={4}>
          <CheckGroup
            title="Bio-Hazmat"
            justified
            info="A hazardous material note will be added to outgoing quote and sales order confirmation emails.  POs will recommend shipping AR condition direct to the repair station.  Notifies receiving dept."
          >
            <Check
              input={bio.input}
              label="Bio-Hazmat"
              icon="fa-flask"
              disabled={disableIfWhManager}
            />
          </CheckGroup>
        </Col>
        <Col md={4}>
          <CheckGroup
            title="Pass/Fail Item"
            justified
            id="warnings"
            info="Disallows exchange outgoing quotes, exchange sales orders and exchange SRPs on POs and inventory. Removes exchange fee from outgoing quote email. Defaults inventory warranty period to 30 days for SV or OH condition."
          >
            <Check
              input={pass_fail.input}
              label="Pass / Fail"
              icon="fa-graduation-cap"
              disabled={disableIfWhManager || disableIfWarehouseDirector}
            />
          </CheckGroup>
        </Col>
      </FormRow>
      <FormRow>
        <Col md={2}>
          <CheckGroup
            title={LLP.toUpperCase()}
            justified
            id="warnings"
            info="For POs, manager approval required if less than 40% life remaining."
          >
            <Check input={llp.input} label={LLP.toUpperCase()} icon="fa-gear" />
          </CheckGroup>
        </Col>
        {llp.input.value && <TotalTimeFields />}
        <Col md={3}>
          <div className="form-group">
            <CheckGroup
              title={properCase(SHELF_LIFE)}
              info="If tagged, will require expiration date to be entered upon receiving. Notifies receiving dept."
            >
              <Field
                name={SHELF_LIFE}
                component={Check}
                label={properCase(SHELF_LIFE)}
              />
            </CheckGroup>
          </div>
        </Col>
        <Col md={3}>
          <CheckGroup title={MILITARY.toUpperCase()} justified>
            <Check
              input={military.input}
              label={MILITARY.toUpperCase()}
              icon="fa-fighter-jet"
            />
          </CheckGroup>
        </Col>
      </FormRow>
      <FormRow>
        <Col md={2}>
          <div className="form-group">
            <CheckGroup
              title={"Export"}
              info="Places any sale on hold for export compliance review."
            >
              <Field
                name={EXPORT_COMPLIANCE}
                component={Check}
                label="Export"
              />
            </CheckGroup>
          </div>
        </Col>
        <Col md={3}>
          <PartTypes formName={formName} />
        </Col>
      </FormRow>
    </React.Fragment>
  );
}

const Warning = PropTypes.shape({
  input: FormTypes.boolInput.isRequired
});

Warnings.propTypes = {
  hazmat: Warning.isRequired,
  bio_hazmat: Warning.isRequired,
  llp: Warning.isRequired,
  pass_fail: Warning.isRequired,
  military: Warning.isRequired
};

export default function WarningList(props) {
  return (
    <Fields
      names={[
        HAZMAT,
        BIO_HAZMAT,
        LLP,
        PASS_FAIL,
        TOTAL_HOURS,
        TOTAL_CYCLES,
        MILITARY
      ]}
      component={Warnings}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/CreatePart/Warnings.jsx